<template>
  <div class="main">
    <v-layout row wrap>
      <div class="card">
        <!-- <v-card-title primary-title><h1>RIEGO</h1></v-card-title> -->
        <h1 class="title">Riego</h1>
        <br />
        <div align="center">
          <v-layout row wrap class="buttons">
            <v-flex>
              <router-link to="/CEReports">
                <div class="items">
                  <v-btn
                    round
                    class="item"
                    flat
                    v-if="$store.state.isUserLoggedIn"
                    >C.E. y pH</v-btn
                  >
                </div>
              </router-link>
            </v-flex>

            <v-flex>
              <router-link to="/Netajet">
                <div class="items">
                  <v-btn
                    round
                    class="item"
                    flat
                    v-if="$store.state.isUserLoggedIn"
                    >Cantidad Riego</v-btn
                  >
                </div>
              </router-link>
            </v-flex>
            <v-flex v-if="isVarilla">
              <router-link to="/VarillaReports">
                <div class="items" color="light-blue">
                  <v-btn
                    round
                    class="item"
                    flat
                    color="light-blue"
                    v-if="$store.state.isUserLoggedIn"
                    >C.E. y pH Varilla</v-btn
                  >
                </div>
              </router-link>
            </v-flex>
            <v-flex>
              <router-link to="/Reservorio">
                <div class="items">
                  <v-btn
                    round
                    class="item"
                    flat
                    v-if="$store.state.isUserLoggedIn"
                    >Reservorio</v-btn
                  >
                </div>
              </router-link>
            </v-flex>
            <v-flex>
              <router-link to="/Joules">
                <div class="items">
                  <v-btn
                    round
                    class="item"
                    flat
                    v-if="$store.state.isUserLoggedIn"
                    >Joules</v-btn
                  >
                </div>
              </router-link>
            </v-flex>
            <!-- <v-flex>
                <router-link to="/Paskal">
                  <div class="items">
                    <v-btn round class="item" flat v-if ="$store.state.isUserLoggedIn">Paskal</v-btn>
                  </div>
                </router-link>
              </v-flex> -->
          </v-layout>
        </div>
        <br />
      </div>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      isVarilla: false,
    };
  },
  created() {
    this.isVarilla = true;
    // this.isVarilla = (day === 2) || (day === 5);
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.main {
  height: 500px !important;
}

.title {
  margin-left: 5%;
  font-size: 40px !important;
}

.card {
  height: 400px;
  margin-left: 5%;
  width: 90%;
  padding: 40px !important;
}

.item {
  font-size: 20px;
  color: white !important;
  background-color: lightgray;
  margin-left: 0% !important;
  width: 70% !important;
}
.buttons {
  margin-top: 5%;
}
</style>
